<template>
    <ModalConfirm
        id="modal-confirm-claim-kas-kecil"
        title="Konfirmasi Klaim Kas"
        :desc="desc"
        :isSubmitting="isSubmitting"
        @submit="$emit('submit')"
    />
</template>

<script>
export default {
    name: "modal-kas-kecil-claim-cash",
    props: {
        desc: { type: String, default: "" },
        isSubmitting: { type: Boolean, default: false },
    },
}
</script>
